export interface Project {
  id: number;
  title: string;
  location: string;
  images: string[];
  previewImage: string;
  description: string;
  builder?: string;
  projektzeitraum?: string;
  leistungen?: string;
  architekt?:
    | string
    | {
        hochbau: string;
        innenausstattung: string;
      };
  nutzung?: string;

  wohnflaeche?: string;
  bruttoGrundflaeche?: string;
  grundstuecksflaeche?: string;

  anzahlZimmer?: string;
  anzahlStellplaetze?: string;
  besonderheit?: string | string[];

  wohneinheiten?: string;
  wohnungsschluessel?: string;
  gewerbeflaeche?: string;
  nutzflaeche?: string;
  gewerbeeinheiten?: string;
  credits?: string;
}

const img = (folder: string, file: string, size: 480 | 1600 = 1600) =>
  `/media/${folder}/${size}/${file}.webp`;


export const featured: Project[] = [
  {
    id: 1,
    title: "Neubau Wohnpark „St. Elisabeth“",
    images: [
      img("elisabeth", "nussfertig-01"),
      img("elisabeth", "nussfertig-02"),
      img("elisabeth", "nussfertig-04"),
      img("elisabeth", "nussfertig-05"),
    ],
    previewImage: img("elisabeth", "nussfertig-01"),
    description: `Inmitten des traditionsreichen Berliner Villenviertels Westend entstand mit dem AVILA Wohnpark St. Elisabeth ein anspruchsvolles Neubauensemble auf dem Gelände einer ehemaligen Klinik. Zwischen Nussbaum-, Akazien- und Kirschenallee wurden drei villenartige Einzelbauten errichtet, die sich harmonisch in das grüne, historisch gewachsene Umfeld einfügen.

Die architektonisch zurückhaltenden, viergeschossigen Baukörper mit aufgesetztem Staffelgeschoss zeichnen sich durch helle Fassaden, großzügige Fensterflächen sowie weitläufige Balkone und Terrassen aus. Insgesamt beherbergen die Gebäude 32 moderne, größtenteils barrierefreie Mietwohnungen, überwiegend in Form großzügiger Drei-Zimmer-Grundrisse mit Wohnflächen zwischen 103 und 129 Quadratmetern. Die Deckenhöhe von 2,60 Metern und bodentiefe, dreifach verglaste Fenster sorgen für eine helle und freundliche Wohnatmosphäre. Die meisten Wohnungen bieten einen unverbaubaren Blick auf die historische Parkanlage mit ihrem teils denkmalgeschützten Baumbestand, der zum Teil bis ins Jahr 1900 zurückreicht.

Der Wohnpark St. Elisabeth vereint klassisches Villenflair mit zeitgemäßem Wohnkomfort. Die Wohnungen verfügen über Tageslichtbäder mit separater Dusche, teilweise auch über ein zusätzliches Gäste-WC. Edles Eichenparkett in den Wohn- und Schlafzimmern, hochwertige Fliesen in Küchen und Korridoren sowie eine angenehme Fußbodenheizung schaffen eine hochwertige, behagliche Atmosphäre. In den Erdgeschosswohnungen wurden Sicherheitsglaselemente eingesetzt; alle Wohnungseingangstüren erfüllen die Anforderungen der Widerstandsklasse 2. Die Küchen in den Häusern B und C sind für Kochinseln vorbereitet, und in den Bädern finden sich Anschlüsse für Waschmaschine und Trockner. Auch die digitale Infrastruktur wurde berücksichtigt: Alle Wohnräume sind an das Breitbandkabelnetz angeschlossen und für moderne Kommunikationstechnik vorverkabelt.

Die drei Gebäude wurden überwiegend aus Kalksandstein errichtet und erfüllen die Anforderungen der Energieeinsparverordnung von 2009. Beheizt wird das Ensemble über einen Anschluss an das Fernwärmenetz der Vattenfall AG. Sämtliche Etagen sowie die Kellergeschosse sind bequem über Aufzüge erreichbar. Die hauseigene Tiefgarage mit 32 Stellplätzen bietet zusätzlichen Komfort und macht den Wohnpark besonders attraktiv für eine urbane Zielgruppe, die auf moderne Standards ebenso Wert legt wie auf stilvolles Wohnen im Grünen.

Der AVILA Wohnpark St. Elisabeth ist ein gelungenes Beispiel für die behutsame Nachverdichtung in einer der charmantesten Wohnlagen Berlins – naturnah, stilvoll und mit hoher Lebensqualität.`,
    builder: "Dr. Fernando International GmbH",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt: "Büro Reichel + Stauth",
    projektzeitraum: "2015",
    nutzung: "Mehrgeschossiger Wohnungsbau",
    wohnflaeche: "ca. 3.847 m²",
    grundstuecksflaeche: "ca. 4.804 m²",
    wohneinheiten: "32",
    anzahlStellplaetze: "32 Tiefgaragenstellplätze",
    location: "Nussbaumallee 37, 39, Akazienallee 40, 14050 Berlin-Westend",
  },

  {
    id: 2,
    title: "Neubau eines Wohn- und Bürogebäudes",
    images: [
      img("kleinaustr", "kleinaustr5"),
      img("kleinaustr", "kleinaustr5-01"),
      img("kleinaustr", "kleinaustr5-02"),
    ],
    previewImage: img("kleinaustr", "kleinaustr5"),
    description: `In der Kleinaustraße 5, im Berliner Bezirk Steglitz-Zehlendorf, entsteht ein hochwertiger Neubau eines dreigeschossigen Wohngebäudes mit ausgebautem Dachgeschoss und einer integrierten Gewerbeeinheit im Erdgeschoss. Das vollunterkellerte Gebäude wird in Massivbauweise errichtet und folgt dem Prinzip einer offenen Bauweise mit einem kristallinen Baukörper.

Die architektonische Gestaltung versteht sich als zeitgemäße Weiterentwicklung des Bautyps „Villa“. Mit seiner eigenständigen Formensprache und hochwertigen Materialien fügt sich das Gebäude harmonisch in die heterogene Nachbarschaft ein, die überwiegend durch postmoderne, mehrgeschossige Wohnhäuser der späten 1970er-Jahre geprägt ist.

Der Baukörper orientiert sich an der Bauflucht der benachbarten Gebäude, wodurch ein straßenseitiger Vorgarten erhalten bleibt. Die Grundform ist unregelmäßig und weicht bewusst von klassischen 90°-Winkeln ab – ein gestalterisches Element, das dem Gebäude seinen kristallinen Charakter verleiht.

Die barrierefreie Gewerbeeinheit im Erdgeschoss ist ebenerdig zugänglich. Die oberen Wohneinheiten sind über ein Sicherheitstreppenhaus sowie einen Personenaufzug erschlossen. Der Hauseingang liegt zur Straßenseite hin. Im Untergeschoss befinden sich neben den Technikräumen auch Mieterkeller, Lagerräume und ein Fahrradabstellraum zur flexiblen Nutzung.

Die äußere Erscheinung wird durch eine hochwertige Klinkerfassade mit bodentiefen Fenstern geprägt. Das Dach ist als hinterlüftetes Holz-Sparrendach mit unregelmäßiger Neigung ausgeführt, inklusive Zwischensparrendämmung, Dachschalung und einer Stehfalzdeckung aus beschichtetem Zinkblech.`,
    builder: "Dr. Fernando International GmbH",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt: "kadawittfeldarchitektur gmbh",
    nutzung: "Wohn- und Bürogebäude",
    projektzeitraum: "2022–2025",
    wohneinheiten: "Wohnungen: 3, Gewerbeeinheit: 1",
    wohnflaeche: "ca. 390 m²",
    grundstuecksflaeche: "ca. 480 m²",
    location: "Kleinaustraße 5, 14169 Berlin-Steglitz-Zehlendorf",
    besonderheit: ["Aufzug vorhanden"],
  },

  {
    id: 3,
    title: "Neubau eines Wohn- und Gewerbequartiers in Cottbus",
    images: [
      img("cottbus", "gulbenerstr-cottbus-03"),
      img("cottbus", "gulbenerstr-cottbus-04"),
      img("cottbus", "gulbenerstr-cottbus-05"),
      img("cottbus", "gulbenerstr-cottbus-06"),
    ],
    previewImage: img("cottbus", "gulbenerstr-cottbus-03"),
    description: `Auf einem ehemaligen Industriegelände, unweit der Technischen Universität Cottbus-Senftenberg, entsteht ein modernes, zukunftsorientiertes Wohnquartier.

Im ersten Schritt werden sämtliche Altgebäude vollständig rückgebaut. Anschließend erfolgt eine Bodensanierung, um die Fläche ökologisch für die zukünftige Nutzung vorzubereiten.

Das neue Quartier wird aus fünf freistehenden Wohngebäuden bestehen, die durch eine gemeinsame Tiefgarage miteinander verbunden sind.

Im Fokus des städtebaulichen Konzepts steht das Modell des Mehrgenerationenwohnens. Geplant sind 124 Studentenapartments, 129 Zwei- bis Drei-Zimmer-Wohnungen und ein Haus für Wohngemeinschaften, z. B. für Menschen mit Demenz, das von einem Sozialträger betrieben wird.

Es entsteht ein urbanes Quartier, das gemeinschaftliches Leben, soziale Durchmischung und generationenübergreifende Teilhabe fördert – eingebettet in eine nachhaltige, zeitgemäße Architektur.`,
    builder:
      "Dr. Fernando International GmbH & Avila Grundbesitz GmbH & Co. KG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung, Gewährleistungsmanagement",
    architekt: "Bräunlin Kolb Architekten GmbH",
    nutzung: "Wohnnutzung",
    wohneinheiten: "ca. 250",
    wohnflaeche: "ca. 12.000 m²",
    grundstuecksflaeche: "ca. 7.706 m²",
    anzahlStellplaetze: "111 PKW-Stellplätze, 136 Fahrradstellplätze",
    projektzeitraum: "2026–2030",
    location: "Gulbener Straße 12, 03046 Cottbus",
  },
];
